import React, { useState, useEffect } from 'react'
import { KhubMap, Button } from '../../../components'
import styleModule from './explorer.module.css'

// When integrate with backend, get this data from database
// import programMapDataNoZoom from '../../../components/khub-map/data/programs-dummy-data-no-zoom'
// import programMapDataNoHover from '../../../components/khub-map/data/programs-dummy-data-no-hover'
import regionDataWithoutZoom from '../../../components/khub-map/data/region-dummy-data-no-zoom'
import auth from '../../../utils/auth'
import { useHistory } from 'react-router-dom'

const Explorer = () => {
  const [programMapData, setProgramMapData] = useState([])
  const { isOfficial, isVerified } = auth()
  const history = useHistory()

  useEffect(() => {
    setProgramMapData(regionDataWithoutZoom)
  }, [isOfficial, isVerified])

  return (
    <div>
      <div className="mb-8 lg:mb-16">
        <KhubMap
          data={programMapData}
          mapClassName={styleModule.map}
          mapStyleColor="light"
        />
      </div>
      <div className="text-center">
        <div className="inline-block">
          <Button thin onClick={() => history.push('/region-map')}>
            Lihat lebih lengkap
          </Button>
        </div>
      </div>
    </div>
  )
}

export { Explorer }
